<template>
  <div id="app">
    <div v-if="isRouterAlive">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
    </div>
    <!--不缓存的视图-->
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>
<script>
export default {
  data() {
    return { isRouterAlive: true };
  },
  provide() {
    return { reload: this.reload };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => (this.isRouterAlive = true));
    },
  },
  mounted() {
    const searchParams = new URLSearchParams(window.location.search);

    if (
      searchParams.get("student_uuid") !== "" &&
      searchParams.get("student_uuid") !== null
    ) {
      localStorage.setItem(
        "studentUuid",
        searchParams.get("student_uuid") || ""
      );
    }

    if (
      searchParams.get("task_uuid") !== "" &&
      searchParams.get("task_uuid") !== null
    ) {
      localStorage.setItem("taskUuid", searchParams.get("task_uuid") || "");
    }
  },
  computed: {},
  watch: {},
};
</script>
<style>
html,
body {
  margin: 0;
  padding: 0;
}
html,
body,
#app {
  height: 100%;
  color: #3d3d3d;
}
a,
router-link {
  text-decoration: none;
  color: #3d3d3d;
  outline: none;
}
ul,
li,
ol,
dt,
dd {
  list-style: none;
  margin: 0;
  padding: 0;
}
img {
  display: block;
}
input:focus,
textarea:focus {
  outline: none;
}
textarea {
  resize: none;
}
input {
  border: none;
}
</style>
